import React, { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { MapPin, Phone } from "lucide-react";

export default function Locations() {
  const [locs, setLocs] = useState([]);
  useEffect(() => { api.get("/locations").then(r => setLocs(r.data)); }, []);
  return (
    <>
      <PageHeader eyebrow="Where we dance" title="Locations" sub="Two convenient studios in Melbourne's west." />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-6">
        {locs.map(l => (
          <div key={l.id} className="card-surface overflow-hidden card-hover">
            {l.image && <img src={l.image} className="w-full aspect-video object-cover" alt=""/>}
            <div className="p-6">
              <h3 className="font-display text-3xl uppercase">{l.name}</h3>
              <div className="text-zinc-400 mt-3 space-y-2 text-sm">
                <div className="flex items-center gap-2"><MapPin size={14} className="text-red-500"/>{l.address}</div>
                {l.phone && <div className="flex items-center gap-2"><Phone size={14} className="text-red-500"/>{l.phone}</div>}
              </div>
              {l.map_url && <a href={l.map_url} target="_blank" rel="noreferrer" className="btn-ghost mt-4 !py-2 !px-3 !text-xs inline-flex">Open in maps</a>}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
